<template>
  <div>
    <fullscreen ref="fullscreen" :fullscreen.sync="isFullScreen">
      <b-row class="m-0 revenueDriverHeader">
        <b-col> </b-col>
        <b-col class="text-right">
          <downloadChart />
        </b-col>
      </b-row>

      <b-row class="m-0 chartTabPanel autoCursor revenueDriverPanel">
        <b-col ref="capture" cols="6" class="py-0">
          <b-card-group deck>
            <!--Card 1-->
            <b-card header="Annual Revenue" header-tag="header" class="m-2 ">
              <div id="annualrevenue_summary_tbl" class="tblWrapper">
                <table>
                  <thead id="annualrevenue_summary_head">
                    <th>Fiscal year end 30-Jun</th>
                    <th class="rightAligned">2016A</th>
                    <th class="rightAligned">2017A</th>
                    <th class="rightAligned">2018A</th>
                    <th class="rightAligned">2019E</th>
                    <th class="rightAligned">2020E</th>
                    <th class="rightAligned">2021E</th>
                  </thead>
                  <tbody id="financial_summary_body">
                    <tr v-for="(item, id) in annualrevenueTableData" :key="id">
                      <td>{{ item["key"] }}</td>
                      <td class="rightAligned">
                        {{ item["2016A"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ item["2017A"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ item["2018A"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ item["2019E"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ item["2020E"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ item["2021E"] | roundOff }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div id="key_company_tbl" class="tblWrapper">
                <h5 class="px-2">Y-o-Y Growth</h5>
                <table>
                  <thead id="key_company_head">
                    <th>Fiscal year end 30-Jun</th>
                    <th class="rightAligned">2016A</th>
                    <th class="rightAligned">2017A</th>
                    <th class="rightAligned">2018A</th>
                    <th class="rightAligned">2019E</th>
                    <th class="rightAligned">2020E</th>
                    <th class="rightAligned">2021E</th>
                  </thead>
                  <tbody id="key_company_body">
                    <tr v-for="(vitem, idx) in yoygrowthTabledata" :key="idx">
                      <td>{{ vitem["key"] }}</td>
                      <td class="rightAligned">
                        {{ vitem["2016A"] | roundOffPer }}
                      </td>
                      <td class="rightAligned">
                        {{ vitem["2017A"] | roundOffPer }}
                      </td>
                      <td class="rightAligned">
                        {{ vitem["2018A"] | roundOffPer }}
                      </td>
                      <td class="rightAligned">
                        {{ vitem["2019E"] | roundOffPer }}
                      </td>
                      <td class="rightAligned">
                        {{ vitem["2020E"] | roundOffPer }}
                      </td>
                      <td class="rightAligned">
                        {{ vitem["2021E"] | roundOffPer }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-card>
          </b-card-group>

          <b-card-group deck>
            <b-card
              header="Revenue Assumptions- Scenario Analysis"
              header-tag="header"
              class="m-2 "
            >
              <b-row class="m-0">
                <table class="assumptnTbl">
                  <thead>
                    <tr>
                      <th></th>
                      <th><img :src="sliderFilter" class="sliderIcon" /></th>
                      <th>
                        <h6>
                          Basic
                          <br />
                          Points
                        </h6>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div class="nameField pt-0">
                          Client (normalized)
                        </div>
                      </td>
                      <td>
                        <b-form-input
                          id="range-1"
                          :value="clientPt"
                          v-model="clientPt"
                          type="range"
                          min="-5"
                          max="5"
                          @change="slideChange('Client')"
                        ></b-form-input>
                      </td>
                      <td>
                        <input
                          type="number"
                          :value="clientPt"
                          class="ptContainer"
                          id="accruedPt"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="nameField pt-0">
                          Server
                        </div>
                      </td>
                      <td>
                        <b-form-input
                          id="range-1"
                          v-model="serverPt"
                          type="range"
                          min="-5"
                          max="5"
                          @change="slideChange('Server')"
                        ></b-form-input>
                      </td>
                      <td>
                        <input
                          type="number"
                          :value="serverPt"
                          class="ptContainer"
                          id="apPt"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="nameField pt-0">
                          MBD (normalized)
                        </div>
                      </td>
                      <td>
                        <b-form-input
                          id="range-1"
                          v-model="mbdPt"
                          type="range"
                          min="-5"
                          max="5"
                          @change="slideChange('MBD')"
                        ></b-form-input>
                      </td>
                      <td>
                        <input
                          type="number"
                          :value="mbdPt"
                          class="ptContainer"
                          id="capexPt"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="nameField pt-0">
                          EDD
                        </div>
                      </td>
                      <td>
                        <b-form-input
                          id="range-1"
                          v-model="eddPt"
                          type="range"
                          min="-5"
                          max="5"
                          @change="slideChange('EDD')"
                        ></b-form-input>
                      </td>
                      <td>
                        <input
                          type="number"
                          :value="eddPt"
                          class="ptContainer"
                          id="deferredPt"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div class="nameField pt-0">
                          OSD
                        </div>
                      </td>
                      <td>
                        <b-form-input
                          id="range-1"
                          v-model="osdPt"
                          type="range"
                          min="-5"
                          max="5"
                          @change="slideChange('OSD')"
                        ></b-form-input>
                      </td>
                      <td>
                        <input
                          type="number"
                          :value="osdPt"
                          class="ptContainer"
                          id="deprPt"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="col-12 mb-3">
                  <button
                    @click="resetSlider"
                    class="btn btn-xs btn-primary text-right"
                  >
                    Reset
                  </button>
                </div>
              </b-row>
            </b-card>
          </b-card-group>
        </b-col>
        <b-col ref="capture" cols="6" class="py-0">
          <b-card-group deck>
            <!--Card 2-->
            <b-card
              header="Revenue ($ millions)"
              header-tag="header"
              class="m-2 "
            >
              <div class="filterBtn row m-0">
                <div class="btnPanel text-center mx-auto my-2">
                  <button
                    class="btn btn-primary btn-xs btnContainer px-3"
                    @click="getRevenueChartData('total')"
                  >
                    Total
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer px-3"
                    @click="getRevenueChartData('Client')"
                  >
                    Client
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer px-3"
                    @click="getRevenueChartData('Server')"
                  >
                    Server
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer px-3"
                    @click="getRevenueChartData('MBD')"
                  >
                    MBD
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer px-3"
                    @click="getRevenueChartData('EDD')"
                  >
                    EDD
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer px-3"
                    @click="getRevenueChartData('OSD')"
                  >
                    OSD
                  </button>
                </div>
              </div>
              <div
                class="chartWrapper"
                id="keyCompanyChart"
                ref="revenueKeyChart"
              >
                <Plotly
                  :data="revenueChartData"
                  :layout="keyCompanyLayout"
                  :display-mode-bar="false"
                  :config="config"
                  ref="plotlyChart"
                ></Plotly>
              </div>
            </b-card>
          </b-card-group>

          <b-card-group deck>
            <!--Card 2-->
            <b-card header="Business Mix" header-tag="header" class="m-2 ">
              <div class="filterBtn row m-0">
                <div class="filterBtn text-center mx-auto my-2">
                  <button
                    :class="{ selectedButton: this.selectedYear === '2016A' }"
                    class="btn btn-primary btn-xs btnContainer1"
                    @click="getbusinessmixChartData('2016A')"
                  >
                    2016A
                  </button>
                  <button
                    :class="{ selectedButton: this.selectedYear === '2017A' }"
                    class="btn btn-primary btn-xs btnContainer1"
                    @click="getbusinessmixChartData('2017A')"
                  >
                    2017A
                  </button>
                  <button
                    :class="{ selectedButton: this.selectedYear === '2018A' }"
                    class="btn btn-primary btn-xs btnContainer1"
                    @click="getbusinessmixChartData('2018A')"
                  >
                    2018A
                  </button>
                  <button
                    :class="{ selectedButton: this.selectedYear === '2019E' }"
                    class="btn btn-primary btn-xs btnContainer1"
                    @click="getbusinessmixChartData('2019E')"
                  >
                    2019E
                  </button>
                  <button
                    :class="{ selectedButton: this.selectedYear === '2020E' }"
                    class="btn btn-primary btn-xs btnContainer1"
                    @click="getbusinessmixChartData('2020E')"
                  >
                    2020E
                  </button>
                  <button
                    :class="{ selectedButton: this.selectedYear === '2021E' }"
                    class="btn btn-primary btn-xs btnContainer1"
                    @click="getbusinessmixChartData('2021E')"
                  >
                    2021E
                  </button>
                </div>
              </div>
              <div class="chartWrapper" id="valuationChart">
                <Plotly
                  :data="businessmixChartData"
                  :layout="pieLayout"
                  :display-mode-bar="false"
                  :config="config"
                  ref="plotlyChart"
                ></Plotly>
              </div>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </fullscreen>
  </div>
</template>

<script>
import { Plotly } from "vue-plotly";
import downloadChart from "@/components/DownloadChart.vue";
import fullscreen from "vue-fullscreen";
import Vue from "vue";
Vue.use(fullscreen);
//import bFormSlider from 'vue-bootstrap-slider/es/form-slider';
import "bootstrap-slider/dist/css/bootstrap-slider.css";
import { mapActions, mapGetters } from "vuex";
import sliderFilter from "@/assets/img/sliderImg.png";
export default {
  name: "Revenue_Drivers",
  components: {
    Plotly,
    downloadChart,
  },
  computed: {
    ...mapGetters({
      annualrevenue: "annualrevenue",
      yoygrowth: "yoygrowth",
      revenuemillions: "revenuemillions",
      revenuechildchartdata: "revenuechildchartdata",
      iMost: "iMost",
      isFullScreen: "isFullScreen",
    }),
    iMostChildren() {
      return this.iMost.child;
    },
    revenueDriverChild() {
      return this.iMostChildren.filter(
        (item) => "Revenue Drivers" === item.objectname
      );
    },
    revenueChartData: {
      get() {
        return this.revenuechildchartdataClone;
      },
      set(newData) {
        let data = JSON.parse(sessionStorage.getItem("revenuechildchartdata"));
        if (newData && newData.length) {
          this.$store.commit("updatedData", {
            key: "revenuechildchartdata",
            data: newData,
          });
        } else {
          this.$store.commit("updatedData", {
            key: "revenuechildchartdata",
            data: data,
          });
        }
      },
    },
    annualrevenueTableData: {
      get() {
        return typeof this.annualrevenueClone.category != "undefined"
          ? this.formatdata(this.annualrevenueClone)
          : this.annualrevenueClone;
      },
      set(newData) {
        let data = JSON.parse(sessionStorage.getItem("annualrevenue"));
        if (newData && newData.length) {
          this.$store.commit("updatedData", {
            key: "annualrevenue",
            data: newData,
          });
        } else {
          this.$store.commit("updatedData", {
            key: "annualrevenue",
            data: data,
          });
        }
      },
    },
    yoygrowthTabledata: {
      get() {
        return typeof this.yoygrowth.category != "undefined"
          ? this.formatdata(this.yoygrowth)
          : this.yoygrowth;
      },
      set(newData) {
        let data = JSON.parse(sessionStorage.getItem("yoygrowth"));
        if (newData && newData.length) {
          this.$store.commit("updatedData", {
            key: "yoygrowth",
            data: newData,
          });
        } else {
          this.$store.commit("updatedData", {
            key: "yoygrowth",
            data: data,
          });
        }
      },
    },
  },
  data() {
    return {
      revenuechildchartdataClone: [],
      annualrevenueClone: [],
      chartTitle: "",
      //sliderValue:[2015,2020],
      min: 2015,
      max: 2020,
      downloadImg: ["fa", "download"],
      zoomImg: ["fas", "expand"],
      zoomOutImg: ["fas", "compress"],
      fullscreen: false,
      sliderFilter: sliderFilter,
      clientPt: 0,
      serverPt: 0,
      mbdPt: 0,
      eddPt: 0,
      osdPt: 0,
      revenueActiveTab: "",
      keyCompanyLayout: {
        title: "",
        width: 550,
        height: 250,
        autosize: true,
        margin: {
          l: "auto",
          r: "auto",
          b: 30,
          t: 30,
          pad: 0,
        },
        showlegend: true,
        xaxis: {
          showgrid: false,
          showline: true,
          zeroline: false,
          fixedrange: true,
          ticks: "outside",
        },
        legend: {
          x: 0,
          y: -0.35,
          orientation: "h",
        },
        yaxis: {
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          fixedrange: true,
          range: [0, 80000],
          nticks: 8,
        },
        yaxis2: {
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          ticksuffix: "%",
          format: "%",
          fixedrange: true,
          range: [0, 15],
          nticks: 8,
          overlaying: "y",
          side: "right",
        },
        type: "stack",
        hoverlabel: { bgcolor: "#FFF" },
        barmode: "stack",
      },
      businessmixChartData: [
        {
          type: "pie",
          values: [],
          labels: [],
          textinfo: "label+value",
          textposition: "outside",
          automargin: true,
        },
      ],
      Linelayout: {
        width: 650,
        height: 220,
        autosize: true,
        margin: {
          l: "auto",
          r: "auto",
          b: 30,
          t: 30,
          pad: 0,
        },
        xaxis: {
          showgrid: false,
          showline: true,
          fixedrange: true,
          zeroline: false,
          ntick: "auto",
          ticks: "outside",
        },
        yaxis: {
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          //ticksuffix:'mm',
          showzero: true,
          fixedrange: true,
          range: [0, 5],
          nticks: 8,
        },
        yaxis2: {
          titlefont: { color: "#333" },
          tickfont: { color: "#333" },
          overlaying: "y",
          side: "right",
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          ticksuffix: "%",
          fixedrange: true,
          range: [-20, 10],
          nticks: 5,
        },
        legend: {
          x: 0.2,
          y: -0.3,
          orientation: "h",
        },
      },
      pieLayout: {
        height: 250,
        margin: { t: 30, b: 30, l: "auto", r: "auto" },
        showlegend: true,
      },
      selectedYear: "",
      config: { responsive: true },
      colorArr: [
        "#C7D7EA",
        "#77A5DD",
        "#4D7A86",
        "#405165",
        "#62C4A4",
        "#DB704C",
        "#FFA292",
        "#CEDCED",
        "#88B0E2",
        "#D65C33",
      ],
    };
  },
  created() {
    let filterChart = this.iMostChildren.filter(
      (item) => "Revenue Drivers" === item.objectname
    );
    // console.log('filterChart-==',filterChart);
    let revenueChild = filterChart[0].child;
    for (var i = 0; i < revenueChild.length; i++) {
      if (revenueChild[i].objectname != "Revenue Drivers") {
        this.getChartDataById({
          id: revenueChild[i].chartId,
          chartName: revenueChild[i].objectname,
        });
      }
    }
    window.addEventListener("resize", this.windowResize);
  },

  destroyed() {
    window.removeEventListener("resize", this.windowResize);
  },
  methods: {
    ...mapActions(["setDownloadInfo", "getChartDataById"]),
    windowResize(e) {
      // console.log('this.$refs.revenueKeyChart.clientWidth-=-==',this.$refs.revenueKeyChart.clientWidth);
      this.keyCompanyLayout.width = this.$refs.revenueKeyChart.clientWidth - 50;
      // console.log('update width-==-',this.keyCompanyLayout.width);
    },
    formatdata(mapData) {
      let tableData = [];
      if (
        typeof mapData.category != "undefined" &&
        mapData.category.length > 0
      ) {
        for (var i = 0; i < mapData.category.length; i++) {
          tableData.push({ key: mapData.category[i] });
          for (var j = 0; j < mapData.xaxis.length; j++) {
            let cat = mapData.category[i].toLowerCase().replace(/\s/g, "");
            tableData[i][mapData.xaxis[j]] = mapData[cat][j];
          }
        }
      }
      return tableData;
    },
    getRevenueChartData(filter) {
      // console.log('revenue data-=-==-=-=-=',this.revenueDriverChild);
      let revenueDriverChildData = this.revenueDriverChild[0].child.filter(
        (item) => "Revenue($million)" === item.objectname.replace(/\s/g, "")
      );
      // console.log('revenue data-=-=revenueDriverChildData=-=-=-=',revenueDriverChildData);
      let revenueChildInfo = revenueDriverChildData[0].child.filter(
        (item) =>
          typeof item.objectname != "undefined" &&
          filter.toLowerCase() === item.objectname.toLowerCase() &&
          item.parent === "y"
      );
      this.revenueActiveTab = filter;
      // console.log('revenue data-=-=revenueChildInfo=-=-=-=',revenueChildInfo);
      this.getChartDataById({
        id: revenueChildInfo[0].chartId,
        chartName: "revenuechildchartdata",
      });
    },
    getbusinessmixChartData(filter) {
      this.selectedYear = filter;
      // console.log("getbusinessmixChartData-=-====",filter);
      // let yoygrowthData = JSON.parse(sessionStorage.getItem("yoygrowth"));
      let yoygrowthData = this.yoygrowth;
      let chartData = this.businessmixChartData[0];
      chartData.name = filter;
      if (this.yoygrowth && this.yoygrowth.category) {
        chartData.labels = yoygrowthData.category.filter(function(item) {
          return (item != "Gross Profit") & (item != "Operating Income");
        });
        chartData.values = [];
        for (let i = 0; i < chartData.labels.length; i++) {
          let key = chartData.labels[i].toLowerCase().replace(/\s/g, "");
          let yearIndex = yoygrowthData.xaxis.indexOf(filter);
          chartData.values.push(
            parseInt(yoygrowthData[key][yearIndex].replace("%", ""))
          );
        }
        this.businessmixChartData[0].marker = {
          colors: this.colorArr,
        };
        // console.log("businessmixChartData-=-=-=", this.businessmixChartData);
      }
    },
    slideChange(key) {
      let data = JSON.parse(sessionStorage.getItem("revenuechildchartdata"));
      let clientPoint = parseInt(this.clientPt);
      let serverPoint = parseInt(this.serverPt);
      let mbdPoint = parseInt(this.mbdPt);
      let eddPoint = parseInt(this.eddPt);
      let osdPoint = parseInt(this.osdPt);
      for (let i = 0; i < data.length; i++) {
        //debugger;
        if (key == "Client") {
          if (typeof data[i].x != "undefined") {
            for (let j = 0; j < data[i].x.length; j++) {
              if (data[i].name == "Client") {
                if (data[i].x[j] == "2019E") {
                  data[i].y[j] = parseFloat(
                    (
                      parseFloat(data[i].y[j]) +
                      0.24 * parseInt(this.clientPt * 100)
                    ).toFixed(2)
                  );
                } else if (data[i].x[j] == "2020E") {
                  data[i].y[j] = parseFloat(
                    (
                      parseFloat(data[i].y[j]) +
                      2.31 * parseInt(this.clientPt * 100)
                    ).toFixed(2)
                  );
                } else if (data[i].x[j] == "2021E") {
                  data[i].y[j] = parseFloat(
                    (
                      parseFloat(data[i].y[j]) +
                      4.1 * parseInt(this.clientPt * 100)
                    ).toFixed(2)
                  );
                }
              } else if (
                data[i].name == "YoY % Change" &&
                (this.revenueActiveTab == "Client" ||
                  this.revenueActiveTab == "Total")
              ) {
                if (data[i].x[j] == "2019E") {
                  data[i].y[j] = parseFloat(
                    (
                      parseFloat(data[i].y[j]) +
                      0.06 * parseInt(this.clientPt * 100)
                    ).toFixed(2)
                  );
                } else if (data[i].x[j] == "2020E") {
                  data[i].y[j] = parseFloat(
                    (
                      parseFloat(data[i].y[j]) +
                      0.01 * parseInt(this.clientPt * 100)
                    ).toFixed(2)
                  );
                } else if (data[i].x[j] == "2021E") {
                  data[i].y[j] = parseFloat(
                    (
                      parseFloat(data[i].y[j]) +
                      0.01 * parseInt(this.clientPt * 100)
                    ).toFixed(2)
                  );
                }
              }
            }
          }
        }
      }
      this.revenueChartData = data;
      // console.log('revenuechildchartdata data-==-=-',this.revenueChartData);
      let annualrevenuedata = JSON.parse(
        sessionStorage.getItem("annualrevenue")
      );
      let annualTableTemp = this.formatdata(annualrevenuedata);

      annualTableTemp.forEach(function(i) {
        if (i["key"] == "Client") {
          i["2019E"] = (
            parseFloat(i["2019E"]) +
            0.24 * clientPoint * 100
          ).toFixed(2);
          i["2020E"] = (
            parseFloat(i["2020E"]) +
            2.31 * clientPoint * 100
          ).toFixed(2);
          i["2021E"] = (
            parseFloat(i["2021E"]) +
            4.1 * clientPoint * 100
          ).toFixed(2);
        }

        if (i["key"] == "Server") {
          i["2019E"] = (
            parseFloat(i["2019E"]) +
            0.51 * parseInt(serverPoint * 100)
          ).toFixed(2);
          i["2020E"] = (
            parseFloat(i["2020E"]) +
            2.6 * parseInt(serverPoint * 100)
          ).toFixed(2);
          i["2021E"] = (
            parseFloat(i["2021E"]) +
            5.1 * parseInt(serverPoint * 100)
          ).toFixed(2);
        }
        if (i["key"] == "MBD") {
          i["2019E"] = (
            parseFloat(i["2019E"]) +
            0.62 * parseInt(mbdPoint * 100)
          ).toFixed(2);
          i["2020E"] = (
            parseFloat(i["2020E"]) +
            3.13 * parseInt(mbdPoint * 100)
          ).toFixed(2);
          i["2021E"] = (
            parseFloat(i["2021E"]) +
            5.8 * parseInt(mbdPoint * 100)
          ).toFixed(2);
        }
        if (i["key"] == "EDD") {
          i["2019E"] = (
            parseFloat(i["2019E"]) +
            0.18 * parseInt(eddPoint * 100)
          ).toFixed(2);
          i["2020E"] = (
            parseFloat(i["2020E"]) +
            1.22 * parseInt(eddPoint * 100)
          ).toFixed(2);
          i["2021E"] = (
            parseFloat(i["2021E"]) +
            2.3 * parseInt(eddPoint * 100)
          ).toFixed(2);
        }
        if (i["key"] == "OSD") {
          i["2019E"] = (
            parseFloat(i["2019E"]) +
            0.07 * parseInt(osdPoint * 100)
          ).toFixed(2);
          i["2020E"] = (
            parseFloat(i["2020E"]) +
            0.4 * parseInt(osdPoint * 100)
          ).toFixed(2);
          i["2021E"] = (
            parseFloat(i["2021E"]) +
            0.81 * parseInt(osdPoint * 100)
          ).toFixed(2);
        }
      });

      this.annualrevenueTableData = annualTableTemp;

      let yoygrowthdata = JSON.parse(sessionStorage.getItem("yoygrowth"));
      let yoygrowthTableTemp = this.formatdata(yoygrowthdata);

      yoygrowthTableTemp.forEach(function(i) {
        if (i["key"] == "Client") {
          i["2019E"] = (
            parseFloat(i["2019E"]) +
            0.003 * parseInt(clientPoint)
          ).toFixed(2);
          i["2020E"] = (
            parseFloat(i["2020E"]) +
            0.009 * parseInt(clientPoint)
          ).toFixed(2);
          i["2021E"] = (
            parseFloat(i["2021E"]) +
            0.01 * parseInt(clientPoint)
          ).toFixed(2);
        }

        if (i["key"] == "Server") {
          i["2019E"] = (
            parseFloat(i["2019E"]) +
            0.002 * parseInt(serverPoint)
          ).toFixed(2);
          i["2020E"] = (
            parseFloat(i["2020E"]) +
            0.01 * parseInt(serverPoint)
          ).toFixed(2);
          i["2021E"] = (
            parseFloat(i["2021E"]) +
            0.01 * parseInt(serverPoint)
          ).toFixed(2);
        }
        if (i["key"] == "MBD") {
          i["2019E"] = (
            parseFloat(i["2019E"]) +
            0.002 * parseInt(mbdPoint)
          ).toFixed(2);
          i["2020E"] = (
            parseFloat(i["2020E"]) +
            0.01 * parseInt(mbdPoint)
          ).toFixed(2);
          i["2021E"] = (
            parseFloat(i["2021E"]) +
            0.01 * parseInt(mbdPoint)
          ).toFixed(2);
        }
        if (i["key"] == "EDD") {
          i["2019E"] = (
            parseFloat(i["2019E"]) +
            0.003 * parseInt(eddPoint)
          ).toFixed(2);
          i["2020E"] = (
            parseFloat(i["2020E"]) +
            0.01 * parseInt(eddPoint)
          ).toFixed(2);
          i["2021E"] = (
            parseFloat(i["2021E"]) +
            0.01 * parseInt(eddPoint)
          ).toFixed(2);
        }
        if (i["key"] == "OSD") {
          i["2019E"] = (
            parseFloat(i["2019E"]) +
            0.003 * parseInt(osdPoint)
          ).toFixed(2);
          i["2020E"] = (
            parseFloat(i["2020E"]) +
            0.01 * parseInt(osdPoint)
          ).toFixed(2);
          i["2021E"] = (
            parseFloat(i["2021E"]) +
            0.01 * parseInt(osdPoint)
          ).toFixed(2);
        }
      });
      this.yoygrowthTabledata = yoygrowthTableTemp;
    },
    resetSlider() {
      this.clientPt = 0;
      this.serverPt = 0;
      this.mbdPt = 0;
      this.eddPt = 0;
      this.osdPt = 0;
      // this.revenuechildchartdataClone = this.getRevenueChartData(
      //   this.revenueActiveTab
      // );
      this.annualrevenueTableData = this.formatdata(this.annualrevenueClone);
      this.yoygrowthTabledata = this.formatdata(this.yoygrowth);
      this.getRevenueChartData("Total");
      this.getbusinessmixChartData("2016A");
    },
  },
  mounted() {
    let filterChart = this.iMostChildren.filter(
      (item) => "Revenue Drivers" === item.objectname
    );
    // console.log('filterChart-==',filterChart);
    let revenueChild = filterChart[0].child;
    for (var i = 0; i < revenueChild.length; i++) {
      if (revenueChild[i].objectname != "Revenue Drivers") {
        this.getChartDataById({
          id: revenueChild[i].chartId,
          chartName: revenueChild[i].objectname,
        });
      }
    }

    this.setDownloadInfo({
      fileName: "Revenue Drivers",
      downloadData: this.$refs.capture,
    });
    // this.getRevenueChartData("Total");
    // this.getbusinessmixChartData("2016A");
    window.addEventListener("resize", this.windowResize);
  },
  filters: {
    roundOff(num) {
      var nf = new Intl.NumberFormat();
      return isNaN(num) ? num : nf.format(num);
    },
    roundOffPer(num) {
      return isNaN(num) ? num : parseFloat(num).toFixed(2) + "%";
    },
  },
  watch: {
    revenuechildchartdata: function(newData, oldData) {
      // console.log('revenuechildchartdata-=watch-=-==-',newData);
      this.revenuechildchartdataClone = this.revenuechildchartdata;
      let maxVal = 0;
      let minVal = 0;
      let lineMaxVal = 0;
      let lineMinVal = 0;
      for (var i = 0; i < newData.length; i++) {
        newData[i].marker = {
          color: this.colorArr[i],
        };
        if (
          newData[i].name != "unallocated" &&
          newData[i].name != "YoY % Change"
        ) {
          maxVal =
            maxVal > Math.max(newData[i].y) ? maxVal : Math.max(newData[i].y);
          minVal = Math.min(newData[i].y);
        } else if (newData[i].name == "YoY % Change") {
          lineMaxVal =
            lineMaxVal > Math.max(newData[i].y)
              ? lineMaxVal
              : Math.max(newData[i].y);
          lineMinVal =
            lineMinVal < Math.min(newData[i].y)
              ? lineMinVal
              : Math.min(newData[i].y);
        }
      }

      this.keyCompanyLayout.yaxis.range = [minVal, maxVal];
      this.keyCompanyLayout.yaxis2.range = [lineMinVal, lineMaxVal];
      //this.keyCompanyLayout.yaxis2.range = []
    },
    yoygrowth: {
      deep: true,
      handler() {
        this.getRevenueChartData("Total");
        this.getbusinessmixChartData("2016A");
      },
    },
    annualrevenue: {
      deep: true,
      handler() {
        this.annualrevenueClone = this.annualrevenue;
      },
    },
  },
};
</script>

<style>
.tblWrapper {
  margin-bottom: 12px;
}
.tblWrapper h5 {
  font-size: 1rem;
  padding-top: 10px;
}
.tblWrapper table {
  border: 1px solid;
  position: relative;
  width: 100%;
  font-size: 11px !important;
  border: none;
}
.tblWrapper table thead {
  width: 100%;
  background: #fff;
  color: #333;
  text-align: left;
  font-size: 11px;
}
.revenueDriverPanel {
  max-height: 60vh;
  overflow: auto;
}
.revenueDriverPanel .card-header {
  padding: 0rem 0.2rem;
  font-size: 0.9rem;
}
.rightAligned {
  text-align: right;
}
.revenueDriverPanel .card-body {
  padding: 0.25rem;
}
.revenueDriverHeader .exportDropDown .btn,
.revenueDriverHeader .fullscreenBtn {
  padding: 0 5px;
}
.revenueDriverPanel .filterBtn .btn {
  margin-right: 5px;
  padding: 0.2rem 0.5rem !important;
  font-size: 0.9rem;
}
.revenueDriverPanel .filterBtn {
  margin: 0 auto;
}
.selectedButton {
  opacity: 0.8;
}
</style>
